import { render, staticRenderFns } from "./ToneOfVoiceSelector.vue?vue&type=template&id=0d850111&"
import script from "./ToneOfVoiceSelector.vue?vue&type=script&lang=js&"
export * from "./ToneOfVoiceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports